module.exports = __webpack_public_path__ + "static/media/options.9ce52875.svg";